var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Alert, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WarningIconYellow } from '../../../assets/images';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getNpsRatingByChasis, getNpsRatingByInstallbase } from '../../../api/url';
import { MuiButton, MuiStack } from '../../../components';
import { MuiCheckBox } from '../../../components/atoms/checkBox';
import ServiceHistory from '../../../components/templates/serviceHistory/serviceHistory';
import { LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../../constants';
import { getListAPI, resetState, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue, mobilenoblack } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import { dateFormate, getTime } from '../../../utils/utils';
import { secondary } from '../../../theme/colors';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { VehicleHistory } from '../../vehicleHistory/pages/vehicleHistory';
import { getInstallbaseDetailsAPICall } from '../../jobCardDetails/services/utils';
import NpsChip from '../../../components/molecules/NPSChip';
import { getLocalStorageItem } from '../../../utils/storageHelper';
export default function VehicleSelectCard(props) {
    var _this = this;
    var _documentDetailsGetBy, _documentDetailsGetBy2, _npsResult$, _preDocumentFetch$dat, _preDocumentFetch$dat2, _preDocumentFetch$dat3, _preDocumentFetch$dat4, _preDocumentFetch$dat5, _preDocumentFetch$dat6, _preDocumentFetch$dat7, _preDocumentFetch$dat8, _preDocumentFetch$dat9, _preDocumentFetch$dat10, _preDocumentFetch$dat11, _preDocumentFetch$dat12, _preDocumentFetch$dat13, _preDocumentFetch$dat14, _preDocumentFetch$dat15, _preDocumentFetch$dat16, _preDocumentFetch$dat17, _preDocumentFetch$dat18, _preDocumentFetch$dat19, _preDocumentFetch$dat20, _preDocumentFetch$dat21, _preDocumentFetch$dat22;
    var onSelectVehicle = props.onSelectVehicle, selectedVehicle = props.selectedVehicle, isCheckBoxVisible = props.isCheckBoxVisible, customerDetails = props.customerDetails, isServiceHistoryLabel = props.isServiceHistoryLabel, isDisabled = props.isDisabled, IsFromParentAPt = props.IsFromParentAPt, onDeSelectVehicle = props.onDeSelectVehicle, vehicleDetails = props.vehicleDetails, getNPS = props.getNPS;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _a = useState(false), isDrawerOpen = _a[0], setIsDrawerOpen = _a[1];
    var _b = useState([]), npsResult = _b[0], setNpsResult = _b[1];
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var _c = useAppSelector(function (state) { return state.crud; }), preDocumentFetch = _c.preDocumentFetch, documentDetailsGetById = _c.documentDetailsGetById, ModuleDetailsGetById = _c.ModuleDetailsGetById, installbaseDetailsById = _c.installbaseDetailsById;
    var _d = useState(false), isSelectCheckbox = _d[0], setIsSelectedCheckbox = _d[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var handleServiceHistoryDrawer = function () {
        // getvehicleHistorydetails()
        setIsDrawerOpen(function (prev) { return !prev; });
    };
    console.error("installbaseDetailsById", installbaseDetailsById);
    console.error("vehicleDetails", vehicleDetails);
    var vehicleDetailsModified = installbaseDetailsById !== null && installbaseDetailsById !== void 0 && installbaseDetailsById.data ? installbaseDetailsById === null || installbaseDetailsById === void 0 ? void 0 : installbaseDetailsById.data : vehicleDetails;
    var documentDetails = (_documentDetailsGetBy = documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) !== null && _documentDetailsGetBy !== void 0 ? _documentDetailsGetBy : ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 ? void 0 : ModuleDetailsGetById.data;
    var NPSRating = (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.NPSResponse) || [];
    var id = useParams().id;
    var documentId = useParams().documentId;
    useEffect(function () {
        if (id || documentId) {
            var _documentDetailsGetBy3, _ModuleDetailsGetById;
            dispatch(resetState(["installbaseSearchResult", "installbaseDetailsById"]));
            if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy3 = documentDetailsGetById.data) !== null && _documentDetailsGetBy3 !== void 0 && _documentDetailsGetBy3.InstallBaseId || ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById !== void 0 && _ModuleDetailsGetById.InstallBaseId) {
                var _documentDetailsGetBy4, _ModuleDetailsGetById2;
                getInstallbaseDetailsAPICall((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.InstallBaseId) || (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.InstallBaseId));
                OnMountCallNPS();
            }
        }
    }, []);
    var onSelectVehicleCallSyncNPS = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var _npsResult$payload, npsResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: getNpsRatingByInstallbase,
                        request: {
                            'InstallBaseId': id
                        }
                    }))];
                case 1:
                    npsResult = _a.sent();
                    setNpsResult(npsResult === null || npsResult === void 0 || (_npsResult$payload = npsResult.payload) === null || _npsResult$payload === void 0 || (_npsResult$payload = _npsResult$payload.value) === null || _npsResult$payload === void 0 ? void 0 : _npsResult$payload.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var OnMountCallNPS = function () { return __awaiter(_this, void 0, void 0, function () {
        var _npsResultByVin$paylo, npsResultByVin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!NPSRating) return [3 /*break*/, 1];
                    setNpsResult(NPSRating);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: getNpsRatingByChasis,
                        request: {
                            'Chassis': vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo
                        }
                    }))];
                case 2:
                    npsResultByVin = _a.sent();
                    setNpsResult(npsResultByVin === null || npsResultByVin === void 0 || (_npsResultByVin$paylo = npsResultByVin.payload) === null || _npsResultByVin$paylo === void 0 || (_npsResultByVin$paylo = _npsResultByVin$paylo.value) === null || _npsResultByVin$paylo === void 0 ? void 0 : _npsResultByVin$paylo.data);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleViewButtonClick = function (item) {
        dispatch(setState({
            key: "preDocumentFetch",
            value: []
        }));
        var buttonClick = item.PreJobCardDocumentName;
        switch (buttonClick) {
            case 'Inspection':
                navigate("/inspection-Detail/".concat(item.id));
                break;
            case 'Appointment':
                navigate("/appointment-Detail/".concat(item.id));
                break;
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack
    // border={isCheckBoxVisible && vehicleDetailsModified?.VinNo == selectedVehicle?.VinNo ? '1px solid red' : '1px solid red'}
    , {
        borderColor: (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.VinNo) == (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo) ? bajajPrimaryBlue : "transparent",
        paddingBottom: (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.VinNo) == (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo) ? 1 : 2
        // padding={isCheckBoxVisible ? 0 : 0}
        // borderRadius={2}
        // paddingTop={isCheckBoxVisible ? 1.5 : 0}
        ,
        sx: {
            border: "".concat(isCheckBoxVisible && selectedVehicle !== null && selectedVehicle !== void 0 && selectedVehicle.EngineNo ? (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.EngineNo) === (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.EngineNo) ? '2px' : '2px' : '1px', " solid ").concat(isCheckBoxVisible && selectedVehicle !== null && selectedVehicle !== void 0 && selectedVehicle.EngineNo ? (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.EngineNo) === (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.EngineNo) ? systemColor.borderColor : systemColor.borderColor : systemColor.grey),
            borderRadius: {
                xs: '8px',
                sm: '8px',
                md: '12px',
                lg: '12px'
            }
        },
        mb: 2
        // display={selectedVehicle?.EngineNo ? selectedVehicle?.EngineNo === vehicleDetailsModified?.EngineNo ? "flex" : 'none' : 'flex'}
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "vehicle-details-card",
        spacing: 0,
        direction: "column",
        width: "100%",
        padding: 2
    }, isCheckBoxVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeItems: 'center'
        },
        gap: 1.5
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        sx: {
            height: '16px',
            width: '16px'
        },
        checkBoxValue: (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.VinNo) === (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo),
        handleChange: function (event) {
            if (event.target.checked) {
                onSelectVehicle();
                setIsSelectedCheckbox(event.target.checked);
                if (vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.InstallBaseId) {
                    onSelectVehicleCallSyncNPS(vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.InstallBaseId);
                }
            }
            else {
                setIsSelectedCheckbox(false);
                if (onDeSelectVehicle) {
                    onDeSelectVehicle();
                }
            }
        },
        id: "vehicleCheckBox"
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'medium',
        sx: {
            marginRight: '15px'
        },
        id: "registration-no"
    }, vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.RegistrationNo ? vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.RegistrationNo : "-"))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0,
        flexDirection: 'column'
    }, isCheckBoxVisible || isSelectCheckbox ? /*#__PURE__*/ React.createElement(MuiStack, {
        paddingLeft: 1.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'normal',
        sx: {
            color: 'secondary.500',
            ml: '20px'
        },
        id: "product-name"
    }, documentDetails !== null && documentDetails !== void 0 && documentDetails.ProductName ? "".concat(documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.ProductName) : vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.ProductName ? vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.ProductName : '-', " ", "(".concat((documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.SKUCode) || (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.SKUCode) || (documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.ProductCode) || (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.ProductCode), ")"))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        id: "registration-no"
    }, vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.RegistrationNo)), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'normal',
        sx: {
            color: systemColor.lightGrey
        },
        id: "product-name"
    }, documentDetails !== null && documentDetails !== void 0 && documentDetails.ProductName ? documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.ProductName : vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.ProductName ? vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.ProductName : '-', " ", "(".concat((documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.SKUCode) || (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.SKUCode) || (documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.ProductCode) || (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.ProductCode), ")"))))), !isCheckBoxVisible || isSelectCheckbox ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: '8px 12px',
        gap: 1,
        mt: '12px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        color: secondary[500]
    }, t('Engine No')), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        id: "engine-no"
    }, vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.EngineNo ? vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.EngineNo : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        color: secondary[500],
        id: "chassis-no"
    }, t('Chassis No:')), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        id: "vin-no"
    }, vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.VinNo ? vehicleDetailsModified.VinNo : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        color: secondary[500],
        id: "date-of-sale"
    }, t('Date of sale :')), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        id: "sales-invoice-date"
    }, vehicleDetailsModified !== null && vehicleDetailsModified !== void 0 && vehicleDetailsModified.SalesInvoiceDate ? dateFormate(vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.SalesInvoiceDate) : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm',
        color: secondary[500],
        id: "date-of-sale"
    }, "NPS :")), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'end'
        },
        spacing: 1.5
    }, typeof (npsResult === null || npsResult === void 0 || (_npsResult$ = npsResult[0]) === null || _npsResult$ === void 0 ? void 0 : _npsResult$.AnswerRating) === 'number' && (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === "MC" ? /*#__PURE__*/ React.createElement(NpsChip, {
        rating: npsResult[0].AnswerRating
    }) : /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: 'sm'
    }, "-")))) : null, preDocumentFetch && (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat = preDocumentFetch.data) === null || _preDocumentFetch$dat === void 0 ? void 0 : _preDocumentFetch$dat.length) > 0 && !IsFromParentAPt && !isServiceHistoryLabel && /*#__PURE__*/ React.createElement("div", {
        style: {
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Alert, {
        icon: /*#__PURE__*/ React.createElement("img", {
            alt: "warning",
            src: WarningIconYellow,
            height: '20px',
            width: "20px",
            style: {
                marginTop: '4px'
            },
            loading: "lazy"
        }),
        style: {
            backgroundColor: '#FFF7E5',
            borderRadius: '8px'
        },
        variant: "outlined",
        severity: "warning"
    }, (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat2 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat2 === void 0 ? void 0 : _preDocumentFetch$dat2.PreJobCardDocumentName) == "Inspection" && Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: '#CC7A00'
    }, "Draft job card ".concat(preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat3 = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat3 !== void 0 && _preDocumentFetch$dat3.SourceDocumentNo ? preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat4 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat4 === void 0 ? void 0 : _preDocumentFetch$dat4.SourceDocumentNo : preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat5 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat5 === void 0 ? void 0 : _preDocumentFetch$dat5.Code, " already exists for this vehicle")) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: '#CC7A00'
    }, "".concat(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat6 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat6 === void 0 ? void 0 : _preDocumentFetch$dat6.PreJobCardDocumentName, " ").concat(preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat7 = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat7 !== void 0 && _preDocumentFetch$dat7.SourceDocumentNo ? preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat8 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat8 === void 0 ? void 0 : _preDocumentFetch$dat8.SourceDocumentNo : preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat9 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat9 === void 0 ? void 0 : _preDocumentFetch$dat9.Code, " already exists for this vehicle")), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        rowSpacing: 1,
        pt: 1,
        spacing: 3
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        sx: {
            color: "#CC7A00"
        },
        id: "date-and-time"
    }, t("Date & time :")), (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat10 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat10 === void 0 ? void 0 : _preDocumentFetch$dat10.PreJobCardDocumentName) === "Appointment" && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    }, preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat11 = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat11 !== void 0 && _preDocumentFetch$dat11.ScheduledDate ? "".concat(dateFormate(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat12 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat12 === void 0 ? void 0 : _preDocumentFetch$dat12.ScheduledDate), " ").concat(getTime(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat13 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat13 === void 0 ? void 0 : _preDocumentFetch$dat13.SlotStartTime)) : '-'), (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat14 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat14 === void 0 ? void 0 : _preDocumentFetch$dat14.PreJobCardDocumentName) === "Inspection" && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6"
    }, preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat15 = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat15 !== void 0 && _preDocumentFetch$dat15.ScheduledDate ? "".concat(dateFormate(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat16 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat16 === void 0 ? void 0 : _preDocumentFetch$dat16.ScheduledDate), " ").concat(getTime(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat17 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat17 === void 0 ? void 0 : _preDocumentFetch$dat17.ScheduledDate)) : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        sx: {
            color: "#CC7A00",
            fontSize: '12px',
            lineHeight: '18px',
            fontWeight: 500
        }
    }, t("Mode :")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        id: "mode-field",
        color: mobilenoblack
    }, preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat18 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat18 === void 0 ? void 0 : _preDocumentFetch$dat18.ModeTypeName)))))), (!isCheckBoxVisible || (vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.VinNo) === (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.VinNo)) && !isServiceHistoryLabel && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3,
        sx: {
            placeContent: (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat19 = preDocumentFetch.data) === null || _preDocumentFetch$dat19 === void 0 ? void 0 : _preDocumentFetch$dat19.length) > 0 && !IsFromParentAPt ? '' : 'end'
        },
        justifyContent: 'flex-end',
        mt: '6px'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "serviceHistory",
        name: t("Vehicle history"),
        sx: {
            padding: 0,
            backgroundColor: 'transparent',
            color: 'primary.500',
            fontWeight: 'medium'
        },
        variant: "text",
        size: "small"
        // onClick={handleServiceHistoryDrawer}
        ,
        onClick: function (e) {
            dispatch(showSurface({
                type: 'Drawer',
                Component: VehicleHistory,
                containerProps: {
                    PaperProps: {
                        sx: {
                            width: {
                                xs: '100%',
                                sm: '60%'
                            },
                            borderRadius: {
                                xs: '8px 8px 0 0',
                                sm: undefined
                            },
                            height: {
                                xs: '95%',
                                sm: '100%'
                            },
                            bgcolor: 'background.secondary'
                        }
                    },
                    anchor: isMobile ? 'bottom' : 'right'
                },
                componentProps: {
                    selectedVinNo: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo,
                    isRightDrawer: true
                }
            }));
        }
    }), (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat20 = preDocumentFetch.data) === null || _preDocumentFetch$dat20 === void 0 ? void 0 : _preDocumentFetch$dat20.length) > 0 && !IsFromParentAPt && /*#__PURE__*/ React.createElement(MuiButton, {
        id: "serviceHistory",
        name: (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat21 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat21 === void 0 ? void 0 : _preDocumentFetch$dat21.PreJobCardDocumentName) == "Inspection" ? t("VIEW_INSPECTION") : (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat22 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat22 === void 0 ? void 0 : _preDocumentFetch$dat22.PreJobCardDocumentName) == "Appointment" ? t("VIEW_APPOINTMENT") : ''
        // sx={{ color: blue, padding: 0, backgroundColor: 'transparent' }}
        ,
        variant: "text",
        sx: {
            color: systemColor.primary,
            fontWeight: 500,
            fontSize: '14px'
        },
        size: "small",
        onClick: function () { return handleViewButtonClick(preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0]); }
    })), isDrawerOpen && /*#__PURE__*/ React.createElement(ServiceHistory, {
        customerDetails: customerDetails,
        vehicleSelected: selectedVehicle !== null && selectedVehicle !== void 0 ? selectedVehicle : vehicleDetailsModified,
        isOpen: isDrawerOpen,
        onClose: function () { return setIsDrawerOpen(function (prev) { return !prev; }); },
        title: t("Service history"),
        installBaseId: vehicleDetailsModified === null || vehicleDetailsModified === void 0 ? void 0 : vehicleDetailsModified.InstallBaseId,
        isServiceHistoryLabel: isServiceHistoryLabel,
        isDisabled: isDisabled
    })));
}
